import { FaStar, FaLocationDot } from 'react-icons/fa6'

const testimonials = [
  {
    name: 'Hendra Wijaya',
    role: 'Owner, NetStar Fiber',
    location: 'Bandung',
    quote:
      'Sejak pakai Radius Trend, proses billing yang dulu memakan waktu 3 hari sekarang selesai otomatis dalam hitungan menit. Isolir otomatisnya sangat membantu mengurangi piutang.',
    avatar: 'https://picsum.photos/seed/hendra/80/80.jpg',
  },
  {
    name: 'Dewi Rahmawati',
    role: 'Admin, JakWiFi Net',
    location: 'Jakarta Timur',
    quote:
      'Dashboard-nya sangat intuitif, bahkan tim admin yang baru pun bisa langsung pakai tanpa training khusus. Integrasi Mikrotiknya seamless, tidak pernah bermasalah.',
    avatar: 'https://picsum.photos/seed/dewi/80/80.jpg',
  },
  {
    name: 'Agus Pratama',
    role: 'CTO, SulawesiNet',
    location: 'Makassar',
    quote:
      'Kami mengelola lebih dari 2000 pelanggan dan Radius Trend mampu menanganinya dengan sangat baik. Support-nya juga responsif, bahkan di hari libur.',
    avatar: 'https://picsum.photos/seed/agus/80/80.jpg',
  },
]

export default function LpTestimonialsSection() {
  return (
    <section
      id="testimoni"
      className="relative py-24 lg:py-32 overflow-hidden"
      aria-labelledby="testimoni-heading"
    >

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-16 reveal">
          <span className="text-ocean-600 font-semibold text-sm tracking-wider uppercase mb-4 block">
            Testimoni
          </span>
          <h2
            id="testimoni-heading"
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight mb-6"
          >
            Dipercaya oleh <span className="gradient-text">Ratusan ISP</span>{' '}
            di Indonesia
          </h2>
          <p className="text-slate-custom text-lg leading-relaxed">
            Dengarkan langsung pengalaman para operator ISP yang telah merasakan
            manfaat Radius Trend.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <article
              key={i}
              className="card-glow rounded-2xl p-7 reveal"
              style={{ transitionDelay: i * 0.12 + 's' }}
            >
              <div className="flex gap-1 mb-5">
                {[...Array(5)].map((_, j) => (
                  <FaStar key={j} className="text-amber-400 text-sm" />
                ))}
              </div>
              <blockquote className="text-slate-custom leading-relaxed mb-6 text-[15px]">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <div className="flex items-center gap-3 pt-5 border-t border-navy-500/30">
                <img
                  src={t.avatar}
                  alt={`Foto ${t.name}`}
                  className="w-11 h-11 rounded-full object-cover border-2 border-ocean-700/30"
                  loading="lazy"
                />
                <div>
                  <div className="font-semibold text-white text-sm">
                    {t.name}
                  </div>
                  <div className="text-slate-custom text-xs">{t.role}</div>
                  <div className="text-ocean-700 text-xs mt-0.5 flex items-center gap-1">
                    <FaLocationDot className="text-[10px]" />
                    {t.location}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}